module.exports = __webpack_public_path__ + "static/media/61ydQvFmtyL._SL1200_.1ab3d9fc.jpg";